import axios from 'axios';
// import router from '../../router';

/**
 * Helper to get base URL and auth token
 */
const getApiConfig = () => {
  const userToken = localStorage.getItem('userToken');
  if (!userToken) {
    router.push({ name: 'login' });
    throw new Error('User not authenticated.');
  }
  
  const baseURL = process.env.VUE_APP_API_URL || 'http://127.0.0.1:3000/api';
  return {
    baseURL,
    headers: { Authorization: `Bearer ${userToken}` }
  };
};

// --- STATE ---
const state = {
  searchResults: [],
  isLoading: false,
};

// --- MUTATIONS ---
const mutations = {
  SET_LOADING(state, isLoading) {
    state.isLoading = isLoading;
  },
  SET_RESULTS(state, results) {
    state.searchResults = results || [];
  },
  CLEAR_RESULTS(state) {
    state.searchResults = [];
  },
  // This mutation removes the reused serials from the list in real-time
  REMOVE_SERIALS_FROM_LIST(state, reusedSerialsArray) {
    const reusedSet = new Set(reusedSerialsArray);
    state.searchResults = state.searchResults.filter(item => !reusedSet.has(item.iSerienr));
  },
};

// --- ACTIONS ---
const actions = {
  /**
   * Performs a search for "used" items (status > 10)
   */
  async performSearch({ commit }, { searchParams }) {
    commit('SET_LOADING', true);
    commit('CLEAR_RESULTS');
    
    try {
      const { baseURL, headers } = getApiConfig();
      // Note: Hitting the new endpoint
      const response = await axios.get(`${baseURL}/reuse-serials`, {
        params: searchParams,
        headers: headers
      });
      commit('SET_RESULTS', response.data);
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 404) {
        commit('SET_RESULTS', []);
        return [];
      }
      console.error('Error in performSearch (reuse):', error);
      throw error;
    } finally {
      commit('SET_LOADING', false);
    }
  },

  /**
   * Reuses selected serial numbers, setting their status to 10
   */
  async reuseSerials({ commit }, { selectedSerials, comment }) {
    // Note: We don't set loading here, as the component has its own 'isProcessing'
    try {
      const { baseURL, headers } = getApiConfig();
      // Hitting the POST endpoint
      const response = await axios.post(`${baseURL}/reuse-serials`, 
        { selectedSerials, comment },
        { headers }
      );
      
      // Update the local state to remove the items
      commit('REMOVE_SERIALS_FROM_LIST', selectedSerials);
      
      // Return the success message
      return response.data;
    } catch (error) {
      console.error('Error in reuseSerials:', error);
      throw error;
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
